import { render, staticRenderFns } from "./UpgradePopUp.vue?vue&type=template&id=3439ae99"
import script from "./UpgradePopUp.vue?vue&type=script&lang=js"
export * from "./UpgradePopUp.vue?vue&type=script&lang=js"
import style0 from "./UpgradePopUp.vue?vue&type=style&index=0&id=3439ae99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports